import { Component } from '@angular/core';
import { Globals } from '../../globals'
import { MenuItem } from 'primeng/api';
import { ISelectedStudent } from '../../Models/ISelectedStudent';

@Component({
  selector: 'ServiceDocumentation',
  templateUrl: './ServiceDocumentation.component.html',
})
export class ServiceDocumentationComponent {
  _myGlobals: Globals;
  selectedStudent: ISelectedStudent;
  serDocMenuItems = [
    //{ label: 'Assign Service to Staff', command: (event: Event) => { this._myGlobals.serDocSelected = 'assignService' } },
    { label: 'IEP Progress Report', command: (event: Event) => { this._myGlobals.serDocSelected = 'iepProgressReport' } },
    { label: 'IEP Service Log by Provider', command: (event: Event) => { this._myGlobals.serDocSelected = 'iepServicelog' } }
    //{ label: 'Progress Reports/Service Logs', command: (event: Event) => { this._myGlobals.serDocSelected = 'progressReports' } }
  ];   

  constructor(private globals: Globals) {    
    this._myGlobals = globals;
  }
}
